import { useContext, useEffect } from 'react';
import { SalesforceContext } from 'src/context/salesforce-context';

export const useKillApplication = (step: string, subStep: string) => {
  const { save, isApplicationKilled, setApplicationKilled } = useContext(SalesforceContext);

  useEffect(() => {
    if (isApplicationKilled) {
      save(step, subStep);
    }
  }, [isApplicationKilled]);

  return { isApplicationKilled, setApplicationKilled };
};
